module.exports = __webpack_public_path__ + "static/media/timeline-copy-4.1b69e481.png";